import Applicant from '@/components/services/NoticeRecovery/Applicant/Manual/index.vue';
import Creditors from '@/components/services/NoticeRecovery/Creditors/index.vue';
import Debtor from '@/components/services/NoticeRecovery/Debtor/index.vue';
import Debtors from '@/components/services/NoticeRecovery/Debtors/index.vue';
import RecoveryDetails from '@/components/services/NoticeRecovery/RecoveryDetails.vue';
import JudgementCreditorBankDetails from '@/components/services/NoticeRecovery/JudgementCreditorBankDetails.vue';
import AccountBankDetails from '@/components/services/NoticeRecovery/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  Creditors,
  Debtor,
  Debtors,
  RecoveryDetails,
  JudgementCreditorBankDetails,
  AccountBankDetails,
  StepDocuments,
];
const steps: unknown[] = [Applicant, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const noticeRecoverySteps: unknown[] = isMrpaEnable(
  StatementType.NOTICE_RECOVERY
)
  ? mrpaSteps
  : steps;
